
import toast from "react-hot-toast"
import { apiConnector } from "../apiConnector"
import { apiClient } from "../apiClient"
import { setmanagers } from '../../slices/manager'

export function Get_Managers(token){
    return async(dispatch)=>{
        try {
            const response = await apiConnector("GET",apiClient.GET_MANAGER,null,{
                Authorization:`Bearer ${token}`
            })
            if(!response.data.success){
                throw new Error(response.data.message)
            }
            dispatch(setmanagers(response.data.data))
            //localStorage.setItem('managers',JSON.stringify(response.data.data))

            toast.success(response.data.message)
            return response
        } catch (error) {
            console.log("Error In Get_Managers Function:",error.message)
            toast.error(error.message)
            return error.response

        }
    }
}
export function Update_Manager(formData,_id){
    const token = localStorage.getItem('token')
    console.log("FormData:",formData,_id)
    return async(dispatch)=>{
        try {
            const response = await apiConnector("PUT",apiClient.UPDATE_MANAGER + `/${_id}`,formData,{
                Authorization:`Bearer ${token}`
            })
            if(!response.data.success){
                throw new Error(response.data.message)
            }
            dispatch(Get_Managers(token))
            toast.success(response.data.message)
            return response
        } catch (error) {
            console.log("Error In Update Manager Function:",error.message)
            toast.error(error.message)
            return error.response
        }
    }
}
export function Create_Manager(formData){
    const token = localStorage.getItem('token')
    console.log("Formdatajhvjhbjh:",formData)
    return async(dispatch)=>{
        try {
            const response = await apiConnector("POST",apiClient.CREATE_MANAGER,formData,{
                Authorization:`Bearer ${token}`
            })
            if(!response.data.success){
                throw new Error(response.data.message)
            }
            dispatch(Get_Managers(token))
            toast.success(response.data.message)
            return response
        } catch (error) {
            console.log("Error In Create_Manager Function:",error.message)
            toast.error(error.message)
            return error.response
        }
    }
}
export function Delete_Manager(_id){
    const token = localStorage.getItem('token')
    return async(dispatch)=>{
        try {
            const response = await apiConnector("DELETE",apiClient.DELETE_MANAGER + `/${_id}`,null,{
                Authorization:`Bearer ${token}`
            })
            if(!response.data.success){
                throw new Error(response.data.message)
            }
            dispatch(Get_Managers(token))
            toast.success(response.data.message)
            return response
        } catch (error) {
            console.log("Error In Delete Managet Api Function:",error.message)
            toast.error(error.message)
            return error.response
        }
    }
}

// SET PASSWORD API FUNCTION
export function Set_Password(managerId, newPassword){
    const token = localStorage.getItem('token')
    return async(dispatch)=>{
        try {
            // Replace :userId param in the URL
            const url = apiClient.FORGOT_MANAGER_PASSWORD + `/${managerId}`
            console.log("Set Password API URL:", url)
            console.log("managerId:", managerId, "newPassword:", newPassword)
            const response = await apiConnector("POST", url, { newPassword: newPassword },{
                Authorization:`Bearer ${token}`
            })
            console.log("Set Password API Response:", response.data)
            if(!response.data.success){
                throw new Error(response.data.message)
            }
            toast.success(response.data.message || "Password updated successfully")
            return response
        } catch (error) {
            const message = error.response?.data?.message || error.message
            console.log("Error In Set_Password Function Api:", message)
            toast.error(message)
            return error.response
        }
    }
}
